import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import { Storage } from '@ionic/storage';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  loggedIn = false;
  constructor(
    public router: Router,
    public storage: Storage
  ) {

  }

  canActivate(): Observable<boolean> {
    return from(this.storage.get('isAuthorized').then((val) => {
      if (val === null) {
        this.router.navigate(['login']);
        return false;
      }
      return val;
    }));
  }
  canActivateChild(): Observable<boolean> {
    return from(this.storage.get('isAuthorized').then((val) => {
      if (val === null) {
        this.router.navigate(['login']);
        return false;
      }
      return val;
    }));
  }
}
